import {
  billingGrupoListResponse,
  createBillingGrupoPayload,
  updateBillingGrupoPayload,
} from 'interfaces/BillingGrupo';
import { paramsQueryString, convertQueryParamsConditionsAndFilterValues } from 'utils/objects';
import api from 'services';

const path = '/billingGrupo';

// Listar billing grupos (com filtros opcionais)
export const getBillingGrupoList = async (
  params?: paramsQueryString,
): Promise<billingGrupoListResponse> => {
  const response = await api.get<billingGrupoListResponse>(`${path}/list`, {
    params: params
      ? convertQueryParamsConditionsAndFilterValues(params)
      : {},
  });
  return response.data;
};

// Buscar billing grupo por ID
export const getBillingGrupoById = async (id: number): Promise<billingGrupoListResponse> => {
  const response = await api.get<billingGrupoListResponse>(`${path}/${id}`);
  return response.data;
};

// Buscar billing grupo por código do produto
export const getBillingGrupoByProductCode = async (
  productCode: number,
): Promise<billingGrupoListResponse> => {
  const response = await api.get<billingGrupoListResponse>(`${path}/product/${productCode}`);
  return response.data;
};

// Criar billing grupo
export const createBillingGrupo = async (
  payload: createBillingGrupoPayload,
): Promise<billingGrupoListResponse> => {
  const response = await api.post<billingGrupoListResponse>(`${path}/`, payload);
  return response.data;
};

// Atualizar billing grupo
export const updateBillingGrupo = async (
  payload: updateBillingGrupoPayload,
): Promise<billingGrupoListResponse> => {
  const { id, ...data } = payload;
  const response = await api.put<billingGrupoListResponse>(`${path}/${id}`, data);
  return response.data;
};

// Deletar billing grupo
export const deleteBillingGrupo = async (id: number): Promise<void> => {
  await api.delete(`${path}/${id}`);
};
